import {useState} from "react";

export default function UkraineStandImages() {
    const [add, setAdd] = useState('')
    setTimeout(() => {
        setAdd('active')
    }, 4000);

    return <img className={`ukraine-stand ukraine-stand--${add}`} src="/images/ukraine_stand.png" width='400' height='400' alt="ukraine_stand"/>;
}